import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import {
  canManageOrganizationMember,
  canManageOrganizationMembers,
  canRemoveOrganizationMember,
} from "../../../../utils/organization-permissions-helpers";
import {
  getPermissionNamesByIds,
  getRoleNameById,
  translateOrganizationRole,
} from "./utils/manage-coaches-utils";

export const ActiveTabCoachComponent = ({ locals, roleName }) => {
  const { t } = useTranslation(["dashboard", "common"]);
  const { usersOrganization, organizationRoles = [] } = locals;
  const { organizationActiveUsers = [] } = usersOrganization;
  //state to control the accordion state
  const [accordionState, setAccordionState] = useState({
    coach: "",
    isOpen: false,
  });
  const theme = locals.activeUser.webAppTheme || "dark";

  /**
   * Function to redirect to edit coach modal
   * @param {*} e
   * @param {*} id
   * @param {*} userCanEdit
   */
  const redirectToModal = (e, id, userCanEdit) => {
    if (userCanEdit) {
      e.preventDefault();
      e.stopPropagation();
      submit(`/actions/refresh`, {
        method: "GET",
        body: {
          "modal[type]": "manage-coach-modal",
          coachId: id,
          roleOrganizationName: roleName,
        },
      });
    }
  };

  /**
   * Function to inactive a coach
   * @param {*} e
   * @param {*} coach
   * @param {*} userCanRemove
   */
  const deleteCoach = (e, coach, userCanRemove) => {
    if (userCanRemove) {
      e.stopPropagation();
      e.preventDefault();
      const confirmText =
        coach && !!coach.athletes && coach.athletes.length > 0
          ? t("manageCoaches.deleteCoachWithAthletesConfirm")
          : t("manageCoaches.deleteCoachConfirm");
      if (process.browser && confirm(confirmText)) {
        submit(`/actions/organizations/remove-user`, {
          method: "POST",
          body: {
            user: coach,
            organizationUserStatus: false,
          },
        });
      }
    }
  };

  return organizationActiveUsers.map((item) => {
    const {
      name = "",
      email = "",
      _id = "",
      organizationPermissions = [],
      organizationRoleId = null,
    } = item;
    const image = getAvatarUrl(
      item,
      null,
      theme,
      theme !== "dark" ? true : false
    );

    const roleNameById = getRoleNameById(organizationRoles, organizationRoleId);
    const roleDisplayName = translateOrganizationRole(t, roleNameById);
    const userCanEdit = canManageOrganizationMember(
      roleName,
      roleNameById,
      _id === locals.activeUser._id
    );
    const userCanRemove = canRemoveOrganizationMember(
      roleName,
      roleNameById,
      _id === locals.activeUser._id
    );

    return (
      <li
        key={_id}
        onClick={() =>
          setAccordionState(
            Object.assign({}, accordionState, {
              coach: _id,
              isOpen: !accordionState.isOpen,
            })
          )
        }
      >
        <article>
          <div className="left">
            <img
              src={image}
              loading="lazy"
              className="profile-picture w-12 h-12 rounded-full"
            />
            <div className="coach-info">
              <p className="s1">{name}</p>
              <p className="p4 opacity-70">{email}</p>
            </div>
          </div>
          <div className="right">
            <span className="subtitle-convert-organization">
              {roleDisplayName}
            </span>
            {canManageOrganizationMembers(roleName) && (
              <button
                role="button"
                data-button-type="outline"
                disabled={userCanEdit ? undefined : true}
                onClick={(e) => {
                  redirectToModal(e, _id, userCanEdit);
                  e.stopPropagation();
                }}
              >
                <span>{t("common:edit")}</span>
              </button>
            )}
            {canManageOrganizationMembers(roleName) && (
              <button
                data-button-type="secondary"
                data-action="cancel"
                disabled={userCanRemove ? undefined : true}
                onClick={(e) => {
                  deleteCoach(e, item, userCanRemove);
                }}
              >
                {t("common:remove")}
              </button>
            )}
          </div>
        </article>

        {/* Permissions section */}
        {accordionState.isOpen && accordionState.coach === _id && (
          <div className="permission-details">
            <p className="s3">
              {t("manageCoaches.permissions")}: {""}
              {`${getPermissionNamesByIds(
                locals.organizationPermissions,
                organizationPermissions,
                t
              )}`}
            </p>
          </div>
        )}
      </li>
    );
  });
};
